import vid1_pic from  "../static/vid1_1.jpg"
import vid2_pic from  "../static/vid2_1.jpg"
import vid3_pic from  "../static/vid3_1.jpg"
import vid4_pic from  "../static/vid4_1.jpg"
import vid5_pic from  "../static/vid5_1.jpg"
import vid6_pic from  "../static/vid6.jpg"
import poster1 from  "../static/poster1.png"
import poster2 from  "../static/poster2.png"
import poster3 from  "../static/poster3.png"
import poster4 from  "../static/poster4.png"
import poster5 from  "../static/poster5.png"
import poster6 from  "../static/poster6.png"
import vid1 from  "../static/vids/CetraRudy_HOME_2_60fps_vimeo.mp4"
import vid2 from  "../static/vids/CetraRudy_STORY_2_30fps_vimeo.mp4"
import vid3 from  "../static/vids/CetraRudy_JOURNEY_2_60fps_vimeo.mp4"
import vid4 from  "../static/vids/CetraRudy_History_rev.mp4"
import vid5 from  "../static/vids/CetraRudy_HEIGHT_2_60fps_vimeo.mp4"
import vid6 from  "../static/vids/CetraRudy_CRAFT_2_fix4_60fps_mix1.mp4"

  export const videos =[
    {
      title: "Architecture",
      slug: "architecture",
      description: "is home",
      cta: "view full video",
      poster: vid1_pic,
      fsPoster: poster1,
      url: vid1
    },
    {
      title: "Every Site",
      slug: "story",
      description: "Has a story",
      cta: "view full video",
      poster: vid6_pic,
      fsPoster: poster2,
      url: vid2
    },
    {
      title: "Height Is",
      slug: "perception",
      description: "Perception",
      cta: "view full video",
      poster: vid5_pic,
      fsPoster: poster3,
      url: vid5
    },
    {
      title: "History",
      slug: "history",
      description: "Matters",
      cta: "view full video",
      poster: vid4_pic,
      fsPoster: poster4,
      url: vid4
    },
    {
      title: "The Intimacy",
      slug: "craft",
      description: "Of Craft",
      cta: "view full video",
      poster: vid3_pic,
      fsPoster: poster5,
      url: vid6
    },
    {
      title: "Journey",
      slug: "journey",
      description: "Builds Legacy",
      cta: "view full video",
      poster: vid2_pic,
      fsPoster: poster6,
      url: vid3
    },
  ]



// WEBPACK FOOTER //
// ./src/data/data.js